import { apiClient } from './api';
import type { MarketMoverView, MarketMoversResponse } from '../types/marketMovers';

export const marketMoversService = {
  async fetchMovers(view: MarketMoverView = 'gainers'): Promise<MarketMoversResponse> {
    return apiClient.get<MarketMoversResponse>(
      `/api/market-data/market-movers/?view=${view}`
    );
  },
};
